module.exports = __webpack_public_path__ + "img/dragon-sririt-logo.4a8f39a0.png";